<template>
  <div>
    <div class="water-panel-body">
      <div class="water-panel-img">
        <img class="hand-tea-drink" src="@/assets/meal_entry/アセット 41@2x.png" width="2262" height="3116" loading="lazy" />
      </div>
      <div class="water-panel-contents">
        <div class="water-question">
          <p class="main-text">今日何杯飲みましたか？<br /><span class="sub-text">（アルコール類は含まない）</span></p>
        </div>
        <div class="water-amount">
          <img v-bind:src="teaCup.img" class="tea-drink" :id="index" v-for="(teaCup, index) in teaCups" @click="pushedTeaDrink(index + 1)" />
          <img class="hand-tea-drink" src="@/assets/meal_entry/アセット 29@2x.png" width="335" height="457" loading="lazy" />
        </div>
        <div class="attention">
          ※1日の摂取目標は1000mlです
        </div>
        <img class="complete" src="@/assets/meal_entry/アセット 8@2x.png" width="906" height="336" @click="pushedDone" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputWaterIntake",
  props: ["ingestedWaterAmount"],
  data() {
    return {
      teaCups: [
        { id: 1,  img: require("@/assets/meal_entry/アセット 19@2x.png"),},
        { id: 2,  img: require("@/assets/meal_entry/アセット 20@2x.png"),},
        { id: 3,  img: require("@/assets/meal_entry/アセット 21@2x.png"),},
        { id: 4,  img: require("@/assets/meal_entry/アセット 22@2x.png"),},
        { id: 5,  img: require("@/assets/meal_entry/アセット 23@2x.png"),},
        { id: 6,  img: require("@/assets/meal_entry/アセット 24@2x.png"),},
        { id: 7,  img: require("@/assets/meal_entry/アセット 25@2x.png"),},
        { id: 8,  img: require("@/assets/meal_entry/アセット 26@2x.png"),},
        { id: 9,  img: require("@/assets/meal_entry/アセット 27@2x.png"),},
        { id: 10, img: require("@/assets/meal_entry/アセット 28@2x.png"),},
      ],
      numberOfDrinks: "",
      isDisplay: Boolean,
      water: "",
    };
  },
  mounted() {
    this.numberOfDrinks = this.ingestedWaterAmount / 150
    for (let i = 0; i < this.numberOfDrinks; i++) {
      this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
     }
  },
  methods: {
    pushedDone() {
      this.$emit("handle-complete")
    },
    pushedTeaDrink(index) {
      if (this.numberOfDrinks === index) {
        if (this.isDisplay) {
          for (let i = 0; i < index; i++) {
            this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
          }
          this.isDisplay = false;
          this.water = 0
          this.$emit("handle-change-water", this.water);
        } else {
          for (let i = 0; i < index; i++) {
            this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
          }
          this.isDisplay = true;
          this.numberOfDrinks = index;
          this.water = this.numberOfDrinks * 150;
          this.$emit("handle-change-water", this.water);
        }
      }

      if (this.numberOfDrinks > index) {
        for (let i = 0; i < 10; i++) {
          this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 19) + "@2x.png");
        }
      }

      if (this.numberOfDrinks !== index) {
        for (let i = 0; i < index; i++) {
          this.teaCups[i].img = require("@/assets/meal_entry/アセット " + (i + 9) + "@2x.png");
          this.numberOfDrinks = index;
        }
        this.isDisplay = true;
        this.water = this.numberOfDrinks * 150;
        this.$emit("handle-change-water", this.water);
      }
    },
  },
};
</script>

<style scoped>
  @import "../assets/css/input_water_intake.css";
</style>



// WEBPACK FOOTER //
// src/molecules/InputWaterIntake.vue